import axios from "axios";

export const isValidEmail = (email) => {

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

export const isValidCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11) return false;


    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let sum = 0;
    let remainder;

    for (let i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;

    for (let i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(10, 11))) return false;

    return true;
}

export const isValidCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]/g, '');

    if (cnpj.length !== 14) return false;

    // Verifica se todos os dígitos são iguais, o que tornaria o CNPJ inválido
    if (/^(\d)\1{13}$/.test(cnpj)) return false;

    // Primeiro dígito verificador
    let sum = 0;
    let weight = 5;
    for (let i = 0; i < 12; i++) {
        sum += parseInt(cnpj[i]) * weight;
        weight--;
        if (weight === 1) weight = 9;
    }
    let digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cnpj[12])) return false;

    // Segundo dígito verificador
    sum = 0;
    weight = 6;
    for (let i = 0; i < 13; i++) {
        sum += parseInt(cnpj[i]) * weight;
        weight--;
        if (weight === 1) weight = 9;
    }
    digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== parseInt(cnpj[13])) return false;

    return true;
};

export const formatCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return cpf;
}

export const formatCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, '');
    cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2'); 
    cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); 
    cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2'); 
    cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2'); 
    return cnpj;
}

export const formatValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
};

export const isValidTelefone = (telefone) => {
    telefone = telefone.replace(/[^\d]/g, '');
    return telefone.length === 11;
};

export const formatTelefone = (telefone) => {
    telefone = telefone.replace(/\D/g, '');
    telefone = telefone.replace(/^(\d{2})(\d)/g, '($1) $2');
    telefone = telefone.replace(/(\d)(\d{4})$/, '$1-$2');
    return telefone;
};

export const isValidPassword = (password) => {
    return password.length >= 6;
}

export const isValidCEP = (cep) => {
    cep = cep.replace(/\D/g, '');
    return cep.length === 8;
};

export const formatCEP = (cep) => {
    cep = cep.replace(/\D/g, '');
    cep = cep.replace(/^(\d{5})(\d)/, '$1-$2');
    return cep;
};

export const fetchEstados = async () => {
    try{
        const url = 'https://acesso.pickngo.online/api/listarestados'
        const data = {
            Pagina: 1,
            Paginacao: -1
        }
        const response = await axios.post(url, data)
        if (response.data.sucesso) {
            return response.data.dados.lista; // Retorna a lista de estados
        } else {
            return []; 
        }
    } catch (error) {
        console.error('Erro ao buscar estados:', error);
        return [];
    }
};

export const buscarCidadesPorEstado = async (estadoID) => {
    try{
        const url = 'https://acesso.pickngo.online/api/listarcidades'
        const data = {
            Pagina: 1,
            Paginacao: -1,
            Filtros: `estadoID == ${estadoID}`,
        }
        const response = await axios.post(url, data)
        if (response.data.sucesso) {
            return response.data.dados.lista; // Retorna a lista de cidades
        } else {
            return []; 
        }
    } catch (error) {
        console.error('Erro ao buscar estados:', error);
        return [];
    }
};



